import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import { GenerateFilterOptions } from 'app/components/quick-filter/generate-or-list-filter/generate-or-list-filter.interface';
import { DispatchFilterModule } from '../dispatch-board/dispatch-board.interface';
import { AdvanceFilterService } from 'app/components/quick-filter/advance-filter/advance-filter.service';
import { AdditionalFilter } from 'app/components/quick-filter/advance-filter/advance-filter.interface';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'dispatch-advanced-filter',
  templateUrl: './dispatch-advanced-filter.component.html',
  styleUrls: ['./dispatch-advanced-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DispatchAdvancedFilterComponent implements OnInit {
  @Input() dispatchTab: 'JOBS' | 'ROUTES';
  @Input() module: DispatchFilterModule;
  @Input() filterOptionalValues: any[] = [];
  @Input() additionalFilters?: AdditionalFilter = {};
  @Output() applyOrSaveFilter: EventEmitter<any> = new EventEmitter();

  filterFieldOptions: any[] = [];
  filterOptionsConfig: GenerateFilterOptions;
  filterDataLoading: boolean = false;

  constructor(
    private _dataCollectorService: DataCollectorService,
    private _dispatchBoardService: DispatchBoardService,
    private advanceFilterService: AdvanceFilterService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getFilterOptions(this.module);
  }

  getFilterOptions(module: DispatchFilterModule): void {
    const metaParam = { locale_key: this._dispatchBoardService.userPreferences?.language || 'en' };
    let metaFilterurl: string = '';
    switch (module) {
      case 'grid':
      case 'scheduler': {
        metaFilterurl = this._dispatchBoardService.getModuleFilters('jobs');
        break;
      }
      case 'employee': {
        metaFilterurl = `${this._dataCollectorService.baseurl()}/jobs/dispatch_board/employee/meta/filter`;
        break;
      }
      case 'grid_route':
      case 'scheduler_route': {
        metaFilterurl = this._dispatchBoardService.getModuleFilters('routes');
        break;
      }
    }
    const preloadFilterMeta = this._dispatchBoardService.filterMeta?.[module];
    if (preloadFilterMeta?.length) {
      this.filterFieldOptions = this._dispatchBoardService.filterMeta[module];
    }
    else {
      this.filterDataLoading = true;
      this._dataCollectorService.getData(metaFilterurl, metaParam)
      .subscribe({
        next: (response: any) => {
        this.filterFieldOptions = response?.data || [];
        this._dispatchBoardService.filterMeta[module] = response?.data || [];
        this.filterDataLoading = false;
        this.changeDetectorRef.markForCheck();
        },
        error: (error: any) => {
        this.filterDataLoading = false;
        }
      });
    }
    this.filterOptionsConfig = {
      footerClass: '',
      titleClass: 'custom-filter-header',
      headerClass: 'mt-2 overflow-y-none dispatch-filter-height',
      extraClass: 'm-0',
      showSaveFilter: false,
      data: {
        parentModule: 'dispatch',
        selectedDispatchTab: this.dispatchTab.toLocaleLowerCase(),
        module: this.module,
      }
    };
    const filterValues: any = this.advanceFilterService.dispatchBoardFilterValues?.[this.filterOptionsConfig.data.selectedDispatchTab]?.[this.module] || [];
    if (filterValues) {
      this.filterOptionalValues = this.sanitizeFilterValues(filterValues);
    }
    this.changeDetectorRef.detectChanges();
  }

  onChangeFilters(event: any): void {
    this.applyOrSaveFilter.emit(event);
  }

  sanitizeFilterValues(filterOptionalValues: any): any {
    if(!['grid_route', 'scheduler_route'].includes(this.module)) {
      filterOptionalValues = this._dispatchBoardService.removeFilterKey('keyword', filterOptionalValues);
    }
    return filterOptionalValues;
  }
}
